export default __webpack_public_path__ + "static/media/WhitneySSm-Medium-Adv_Web.39259977.woff";